import { QueryProvider } from '@/app/providers/QueryProvider';
import { router } from '@/app/router';
import { AppOnlyDialog } from '@/shared/components/app-guide/AppOnlyDialog';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from 'sonner';

function App() {
  return (
    <QueryProvider>
      <RouterProvider router={router} />
      {/* 스낵바 — 상단 가운데 3초 (M-03), 모양은 Figma M-21 스낵바: #1F2024 · radius 10 · 12.5px 흰 글자 */}
      <Toaster
        position="top-center"
        toastOptions={{
          unstyled: true,
          classNames: {
            toast:
              'flex w-full flex-col gap-0.5 rounded-[10px] bg-snackbar px-4 py-3 shadow-[0_8px_28px_rgb(0_0_0/18%)]',
            title: 'text-[12.5px] leading-[19px] font-medium text-white',
            description: 'text-xs leading-[18px] text-white/70',
          },
        }}
      />
      {/* X6 앱 전용 기능 공통 팝업 */}
      <AppOnlyDialog />
    </QueryProvider>
  );
}

export default App;
